import React from "react";
import { Link } from "react-router-dom";

export default function YooLogo({ variant = "funny", size = "md" }) {
  const sizeClasses = {
    sm: "text-xl",
    md: "text-2xl",
    lg: "text-3xl",
  };

  return (
    <Link to="/" className={`font-bold ${sizeClasses[size]} flex items-center`}>
      <span className="text-green-500">YOO!</span>
      {variant === "funny" && <span className="text-blue-700 ml-1">FUNNY</span>}
    </Link>
  );
}
